module.exports = __webpack_public_path__ + "img/visa.550271b7.png";